import { takeLatest } from "redux-saga/effects";
import { createAction } from "redux-smart-actions";
import { deleteSaga } from "src/request/delete";
import { getSaga } from "src/request/get";
import { postSaga } from "src/request/post";
import { putSaga } from "src/request/put";
import { SagaActionParams } from "src/request/types";

/**
 * Pazarlama Sitesi V2 — admin içerik CRUD sagaları.
 * Backend: /api/admin/websitev2/{type} (hero-slides, modules, solutions, stats, steps,
 * testimonials, blog, helpcategories, helparticles, faqs). JSON tabanlı entity'ler
 * (DataJson + düz kolonlar). Tüm tipler aynı şekil ile yönetilir.
 */
const base = "/api/admin/websitev2/";

const makeCrud = (key: string, type: string) => ({
  type,
  list: createAction(`MKTV2_${key}_LIST`, ({ payload, params }: SagaActionParams<any>) => ({ payload, url: base + type + (params ? params : "") })),
  create: createAction(`MKTV2_${key}_CREATE`, ({ payload, body }: SagaActionParams<any>) => ({ payload, url: base + type, body })),
  update: createAction(`MKTV2_${key}_UPDATE`, ({ payload, id, body }: SagaActionParams<any>) => ({ payload, url: base + type + "/" + id, body })),
  del: createAction(`MKTV2_${key}_DELETE`, ({ payload, id }: SagaActionParams<any>) => ({ payload, url: base + type + "/" + id })),
});

export const MKTV2 = {
  heroslides: makeCrud("HEROSLIDES", "hero-slides"),
  modules: makeCrud("MODULES", "modules"),
  solutions: makeCrud("SOLUTIONS", "solutions"),
  stats: makeCrud("STATS", "stats"),
  steps: makeCrud("STEPS", "steps"),
  testimonials: makeCrud("TESTIMONIALS", "testimonials"),
  blog: makeCrud("BLOG", "blog"),
  helpcategories: makeCrud("HELPCAT", "helpcategories"),
  helparticles: makeCrud("HELPART", "helparticles"),
  faqs: makeCrud("FAQS", "faqs"),
};

export type Mktv2TypeKey = keyof typeof MKTV2;

const marketingV2Saga = Object.values(MKTV2).flatMap((c) => [
  takeLatest<any>(c.list.toString(), (p: any) => getSaga<any>(p)),
  takeLatest<any>(c.create.toString(), (p: any) => postSaga<any>(p)),
  takeLatest<any>(c.update.toString(), (p: any) => putSaga<any>(p)),
  takeLatest<any>(c.del.toString(), (p: any) => deleteSaga<any>(p)),
]);

export default marketingV2Saga;
